/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_Wrapper_QueryVariables = {
    accountID?: string | null;
};
export type App_Wrapper_QueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"Wrapper_viewer">;
    } | null;
    readonly account: {
        readonly " $fragmentRefs": FragmentRefs<"Wrapper_account">;
    };
};
export type App_Wrapper_Query = {
    readonly response: App_Wrapper_QueryResponse;
    readonly variables: App_Wrapper_QueryVariables;
};



/*
query App_Wrapper_Query(
  $accountID: ID
) {
  viewer {
    ...Wrapper_viewer
    id
  }
  account(input: {accountID: $accountID}) {
    ...Wrapper_account
    id
  }
}

fragment AccountDropdown_accounts on Account {
  id
  name
  userMembership {
    isDefault
  }
}

fragment AccountOptionsDropdown_account on Account {
  id
  name
  userMembership {
    isDefault
  }
  merchant {
    payments {
      stripeSetupStatus
    }
    id
  }
}

fragment AccountSelector_account on Account {
  name
  userMembership {
    isDefault
  }
  ...AccountOptionsDropdown_account
}

fragment AccountSelector_accounts on Account {
  ...AccountDropdown_accounts
}

fragment Header_account on Account {
  ...AccountSelector_account
  merchant {
    payments {
      stripeSetupStatus
    }
    id
  }
}

fragment Header_viewer on User {
  id
  email
  userAccounts {
    ...AccountSelector_accounts
    id
  }
  ...UserDropdown_user
}

fragment UserDropdown_user on User {
  firstName
  lastName
  profileURL
}

fragment Wrapper_account on Account {
  ...Header_account
}

fragment Wrapper_viewer on User {
  id
  email
  ...Header_viewer
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountID"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "accountID",
        "variableName": "accountID"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountMembershipResponse",
  "kind": "LinkedField",
  "name": "userMembership",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "App_Wrapper_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Wrapper_viewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Wrapper_account"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "App_Wrapper_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "userAccounts",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileURL",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Merchant",
            "kind": "LinkedField",
            "name": "merchant",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Payments",
                "kind": "LinkedField",
                "name": "payments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stripeSetupStatus",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5ea617e5825a3b7dcc905682d0f60bb4",
    "id": null,
    "metadata": {},
    "name": "App_Wrapper_Query",
    "operationKind": "query",
    "text": "query App_Wrapper_Query(\n  $accountID: ID\n) {\n  viewer {\n    ...Wrapper_viewer\n    id\n  }\n  account(input: {accountID: $accountID}) {\n    ...Wrapper_account\n    id\n  }\n}\n\nfragment AccountDropdown_accounts on Account {\n  id\n  name\n  userMembership {\n    isDefault\n  }\n}\n\nfragment AccountOptionsDropdown_account on Account {\n  id\n  name\n  userMembership {\n    isDefault\n  }\n  merchant {\n    payments {\n      stripeSetupStatus\n    }\n    id\n  }\n}\n\nfragment AccountSelector_account on Account {\n  name\n  userMembership {\n    isDefault\n  }\n  ...AccountOptionsDropdown_account\n}\n\nfragment AccountSelector_accounts on Account {\n  ...AccountDropdown_accounts\n}\n\nfragment Header_account on Account {\n  ...AccountSelector_account\n  merchant {\n    payments {\n      stripeSetupStatus\n    }\n    id\n  }\n}\n\nfragment Header_viewer on User {\n  id\n  email\n  userAccounts {\n    ...AccountSelector_accounts\n    id\n  }\n  ...UserDropdown_user\n}\n\nfragment UserDropdown_user on User {\n  firstName\n  lastName\n  profileURL\n}\n\nfragment Wrapper_account on Account {\n  ...Header_account\n}\n\nfragment Wrapper_viewer on User {\n  id\n  email\n  ...Header_viewer\n}\n"
  }
};
})();
(node as any).hash = '0e0c907259b3b3de355f8c3590650054';
export default node;
